// Locks body scroll while `active` is true (modals, drawers, bottom sheets).
// Restores the previous overflow value on cleanup so nested locks behave.
import { useEffect } from 'react';

export function useScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [active]);
}

export default useScrollLock;
